/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkExperienceTypeFromJSON, WorkExperienceTypeToJSON, } from './WorkExperienceType.js';
/**
 * Check if a given object implements the WorkExperienceDto interface.
 */
export function instanceOfWorkExperienceDto(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('functionTitle' in value) || value['functionTitle'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('company' in value) || value['company'] === undefined)
        return false;
    if (!('startYear' in value) || value['startYear'] === undefined)
        return false;
    return true;
}
export function WorkExperienceDtoFromJSON(json) {
    return WorkExperienceDtoFromJSONTyped(json, false);
}
export function WorkExperienceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'type': WorkExperienceTypeFromJSON(json['type']),
        'functionTitle': json['functionTitle'],
        'description': json['description'],
        'company': json['company'],
        'startYear': json['startYear'],
        'endYear': json['endYear'] == null ? undefined : json['endYear'],
    };
}
export function WorkExperienceDtoToJSON(json) {
    return WorkExperienceDtoToJSONTyped(json, false);
}
export function WorkExperienceDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': WorkExperienceTypeToJSON(value['type']),
        'functionTitle': value['functionTitle'],
        'description': value['description'],
        'company': value['company'],
        'startYear': value['startYear'],
        'endYear': value['endYear'],
    };
}
